<template lang="pug">
  div.container
    el-form(:model="model" label-position="top" label-width="12em")
      vue-form-generator(
        :schema="schema",
        :model="model",
        :options="formOptions"
        ref="form",
        @model-updated="onModelUpdated"
      )
    validation-observer(ref='observer' tag='div' )
      el-row.margin.ml-15
        el-row(:span="24").margin.mb-20
          app-label(label="O interessado possui outros processos de titulação de terra no Estado da Bahia?", :required="true")
          el-select(v-model="model.titulacaoInteressado.possui", @change="changePossuiTitulacao($event, 'titulacaoInteressado')")
            el-option(
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value",
            )
        el-row(v-if="model.titulacaoInteressado.possui").margin
          el-row(:gutter="30").margin
            el-col(:span="8")
              validation-provider(rules="required", v-slot="{ errors }", name="N° do processo da titulação do interessado")
                app-label(label="Processo", :required="true")
                el-input.input(
                  v-model="model.titulacaoInteressado.processo"
                  type="text",
                  :class="{'erro' : errors.length}"
                )
                span.help.erro(v-if="errors.length") {{ errors[0] }}
            el-col(:span="8")
              validation-provider(rules="required", v-slot="{ errors }", name="Municipio/Comunidade da titulação do interessado")
                app-label(label="Município/Comunidade:", :required="true")
                el-input.input(
                  v-model="model.titulacaoInteressado.municipio"
                  type="text",
                  :class="{'erro' : errors.length}"
                )
                span.help.erro(v-if="errors.length") {{ errors[0] }}
            el-col(:span="8")
              validation-provider(rules="required", v-slot="{ errors }", name="Denominação/Área da titulação do interessado")
                app-label(label="Denominação/Área:", :required="true")
                el-input.input(
                  v-model="model.titulacaoInteressado.area"
                  type="text",
                  :class="{'erro' : errors.length}"
                )
                span.help.erro(v-if="errors.length") {{ errors[0] }}
          el-row(:gutter="30").margin
            el-col(:span="8")
              validation-provider(rules="required", v-slot="{ errors }", name="Sit/Modal da titulação do interessado")
                app-label(label="Sit/Modal:", :required="true")
                el-input.input(
                  v-model="model.titulacaoInteressado.modal"
                  type="text",
                  :class="{'erro' : errors.length}"
                )
                span.help.erro(v-if="errors.length") {{ errors[0] }}
        el-row(:span="24").margin.mb-20
          app-label(label="O cônjuge/convivente e/ou irmão(s) possui outros processos de titulação de terra no Estado da Bahia?", :required="true")
          el-select(v-model="model.titulacaoConjuge.possui", @change="changePossuiTitulacao($event, 'titulacaoConjuge')")
            el-option(
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value",
            )
        el-row(v-if="model.titulacaoConjuge.possui").margin
          el-row(:gutter="30").margin
            el-col(:span="8")
              validation-provider(rules="required", v-slot="{ errors }", name="N° do processo da titulação do cônjuge")
                app-label(label="Processo", :required="true")
                el-input.input(
                  v-model="model.titulacaoConjuge.processo"
                  type="text",
                  :class="{'erro' : errors.length}"
                )
                span.help.erro(v-if="errors.length") {{ errors[0] }}
            el-col(:span="8")
              validation-provider(rules="required", v-slot="{ errors }", name="Municipio/Comunidade da titulação do cônjuge")
                app-label(label="Município/Comunidade:", :required="true")
                el-input.input(
                  v-model="model.titulacaoConjuge.municipio"
                  type="text",
                  :class="{'erro' : errors.length}"
                )
                span.help.erro(v-if="errors.length") {{ errors[0] }}
            el-col(:span="8")
              validation-provider(rules="required", v-slot="{ errors }", name="Denominação/Área da titulação do cônjuge")
                app-label(label="Denominação/Área:", :required="true")
                el-input.input(
                  v-model="model.titulacaoConjuge.area"
                  type="text",
                  :class="{'erro' : errors.length}"
                )
                span.help.erro(v-if="errors.length") {{ errors[0] }}
          el-row(:gutter="30").margin
            el-col(:span="8")
              validation-provider(rules="required", v-slot="{ errors }", name="Sit/Modal da titulação do cônjuge")
                app-label(label="Sit/Modal:", :required="true")
                el-input.input(
                  v-model="model.titulacaoConjuge.modal"
                  type="text",
                  :class="{'erro' : errors.length}"
                )
                span.help.erro(v-if="errors.length") {{ errors[0] }}
</template>
<script>

import { mapActions } from 'vuex'
import { component as VueFormGenerator } from 'vue-form-generator'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { schemas } from './schemas'

export default {
  components: {
    VueFormGenerator,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    despacho: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      default: 'NAO_ONEROSO'
    }
  },

  data () {
    return {
      options: [
        { label: 'Sim', value: true },
        { label: 'Não', value: false }
      ],
      model: {
        numeroProcesso: '',
        numeroSei: '',
        interessado: null,
        titulacaoInteressado: {
          possui: false,
          processo: '',
          municipio: '',
          area: '',
          modal: ''
        },
        titulacaoConjuge: {
          possui: false,
          processo: '',
          municipio: '',
          area: '',
          modal: ''
        }
      },
      schema: {},
      nomeSchema: '',
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateBeforeSave: true,
        despacho: null,
        //  tipoModelo 5 corresponde à modelos de registro de imovel
        tipoModelo: 5
      }
    }
  },

  async mounted () {
    this.nomeSchema = this.tipo
    this.schema = schemas.emissao_certidao_area[this.tipo]
    this.formOptions.despacho = {
      idProcesso: this.despacho.processo?.id,
      tipo: this.despacho.tipo,
      perfil: this.despacho.perfil
    }
    this.montarCertidaoArea()
  },

  methods: {
    async save () {
      const valido = this.formOptions.validateBeforeSave === false || await this.validate()
      if (valido) {
        return this.salvarDespacho()
      } else {
        return undefined
      }
    },

    salvarDespacho () {
      let despacho = this.despacho
      despacho.certidaoArea = {certidao: {...this.model}}
      return despacho
    },

    async validate () {
      const valido = await this.$refs.observer.validate() && await this.$refs.form.validate()
      return valido
    },

    ...mapActions({
      getInteressado: 'cadastro/getInteressado'
    }),

    async montarCertidaoArea () {
      let model = {...this.model}
      if (this.despacho?.certidaoArea?.certidao) {
        model = {...this.despacho?.certidaoArea?.certidao}
        model.numeroSei = this.despacho?.numeroSei
      } else {
        model.interessado = (await this.getInteressado(this.despacho.processo.numeroProtocolo))[0]
        model.numeroProcesso = this.despacho?.processo?.numeroProcesso
        model.numeroSei = this.despacho?.numeroSei
      }
      this.model = model
    },
    async onModelUpdated (newValue, schema) {},
    changePossuiTitulacao (value, titulacao) {
      if (!value) {
        this.model[titulacao] = {
          possui: false,
          processo: '',
          municipio: '',
          area: '',
          modal: ''
        }
      }
    }
  }
}

</script>
<style lang="scss">
@import "@/assets/styles/_variables.scss";

.mb-20 {
  margin-bottom: 20px;
}

.none {
  border: none;
}
.el-form-item__content {
  text-align: left;
}

.el-form-item__content .el-select {
  width: 100%;
}

.el-form-item__label {
  color: $font-dark-color;
  font-size: 14px;
  font-weight: bold;
}

// .el-form-item__label::after {
//   content: "*";
//   color: firebrick;
//   font-size: 14px;
//   font-weight: bold;
// }

.error {
  .field-wrap {
    .el-form-item {
      .el-form-item__content {
        border: 1px solid firebrick;
        border-radius: 10px;
        border-color: firebrick;
        -webkit-box-shadow: inset 0 1px 2px #ff867c , 0 0 9px firebrick;
        box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
      }
    }
  }
}

.erro {
  border: 1px solid firebrick;
  border-radius: 4px;
  border-color: firebrick;
  -webkit-box-shadow: inset 0 1px 2px #ff867c , 0 0 9px firebrick;
  box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
}

.help-block {
  color: firebrick;
}

.app-container {
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  width: 50%;
  margin: 0 auto;
}

.ml-15 {
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppFormularioCertidaoArea.vue